import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  shadows: Array(25).fill('none'),
  palette: {
    primary: {
      // light: '#757ce8',
      main: '#027EDD',
      // dark: '#002884',
      contrastText: '#ffffff',
    },
    secondary: {
      // light: '#ff7961',
      main: '#027EDD',
      // dark: '#ba000d',
      // contrastText: '#000',
    },
    custom: {
      component: '#00bfa5',
      componentText: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['Roboto'].join(','),
  },
  overrides: {
    MuiListItemIcon: {
      root: {
        display: 'block',
        minWidth: 'none',
      },
    },
  },
});

export default theme;
